import { ref } from "vue"

// Module-level (singleton) state: whether the mobile voice-call Drawer is currently expanded
// (full screen) or minimized to the floating bubble (`FloatingCallBubble.vue`). The call itself
// (LiveKit connection) lives entirely in `groupsStore`/`liveKitManager` independent of this — this
// ref only controls which of the two mobile presentations is showing. Shared across the whole app
// so any screen (channel list, group page, etc.) can join/return-to a call the same way.
const isCallExpanded = ref(false)

export function useCallOverlay() {
  function expandCall() {
    isCallExpanded.value = true
  }

  function minimizeCall() {
    isCallExpanded.value = false
  }

  return { isCallExpanded, expandCall, minimizeCall }
}
